<template>
  <div>
    <div class="mainVideoWindow">
      <video ref="videoMain" class="mainVideo"></video>
    </div>
    <div id="otherArea" ref="otherAreaDom" class="videoSelfWindow">
      <div ref="videoOtherArea"></div>
      <div>
        <video ref="videoSelf" muted></video>
      </div>
    </div>

    <video-setting
      id="videoSetting"
      v-if="isViewVideoSetting"
      class="leftWindow window"
      v-bind:sora-data="soraData"
      v-bind:sora-room-id="selectRoomId"
      v-bind:sora-codec="selectCodec"
      v-bind:sora-call-room-id="callRoomId"
      v-bind:update-trigger="videoSettingUpdateTrigger"
      v-on:video-setting="setVideoSetting"
    />
    <video-ctr
      v-if="selectRoomId"
      v-on:action-ctr="actionCtr"
      v-on:send-file="sendFile"
      v-bind:select-room-id="selectRoomId"
      v-bind:is-view-setting="isViewVideoSetting"
      v-bind:is-request-shot="isRequestImage"
      v-bind:is-mute-on="isSelfMute"
      v-bind:is-video-on="isSelfViewVideo"
      v-bind:is-other-video="isOtherVideoView"
      v-bind:is-send-file="isSendFile"
      class="ctrWindow"
    />

    <video-draw
      v-if="drawSoraImageBase64!=null"
      v-on:update-data="actionDrawUpdate"
      v-on:fix-data="actionDrawFix"
      v-bind:sora-image-base64="drawSoraImageBase64"
      class="editWindow window"
    />

    <div
      class="modal"
      v-bind:class="{ 'is-active': fileAccessToken!=null }"
      ref="receiveFileWindow"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">ファイルを受信しました。</p>
        </header>
        <footer class="modal-card-foot">
          <a href="#" target="_blank" ref="receiveFileLink" class="button is-success">ファイルを開く</a>
          <button class="button" @click="receiveFileClose">閉じる</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import VideoSetting from "@/components/VideoSetting";
import VideoDraw from "@/components/VideoDraw";
import VideoCtr from "@/components/VideoCtr";
import UserMedia from "@/api/usermedia";
import ServerAccess from "@/api/serveraccess";

export default {
  name: "Video",
  data() {
    return {
      currentPublisher: null,
      isSoraWaitPolling: true,
      isViewVideoSetting: true,
      videoSettingUpdateTrigger: 1,
      videoSettingData: null,
      selectRoomId: null,
      selectCodec: "VP8",
      isRequestImage: false,
      requestImageId: false,
      requestImageTimer: null,
      drawSoraImageBase64: null,
      drawSoraImageBaseClientId: null,
      callRoomId: null,
      isSelfViewVideo: true,
      isSelfMute: false,
      isOtherVideoView: true,
      isSendFile: false,
      fileAccessToken: null,
    };
  },
  props: {
    soraData: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    // 設定がない場合にはログインへ飛ばす
    if (!this.soraData.sora) {
      this.$router.push({
        name: "login",
      });
    }
  },
  mounted() {
    // wait用のポーリングを開始する
    this.isSoraWaitPolling = true;
    this.polling();

    this.$refs.videoMain.addEventListener("loadedmetadata", () => {
      const w = this.$refs.videoMain.videoWidth;
      const h = this.$refs.videoMain.videoHeight;
      // 縦長の場合
      if (w / h < 1) {
        this.$refs.videoMain.classList.remove("mainVideo");
        this.$refs.videoMain.classList.add("mainVideoWidthHalf");
      } else {
        this.$refs.videoMain.classList.add("mainVideo");
        this.$refs.videoMain.classList.remove("mainVideoWidthHalf");
      }
    });

    if (this.soraData.sora) {
      window.addEventListener("beforeunload", async (event) => {
        // 認証側のログインから離脱
        try {
          let body = await ServerAccess.setSoraLogout(this.soraData);
        } catch (e) {
          console.log(e);
        }

        // sora側のログインから離脱
        if (this.currentPublisher) {
          let clientId = this.currentPublisher.clientId;
          try {
            if (this.currentPublisher._ws) {
              this.currentPublisher._ws.send(
                JSON.stringify({ type: "disconnect" })
              );
            }
            await this.currentPublisher.disconnect();
          } catch (e) {
            console.log(e);
          }
        }
      });
    }
  },
  beforeDestroy() {
    // WebRTCの接続を解除する
    // リロード処理が入るためmountedでのbeforeunloadのセットで行う
    // ビデオオブジェクトがバックグラウンドで可動し続ける場合があるため削除する
    // if (
    //   this.$refs.videoSelf &&
    //   this.$refs.videoSelf.srcObject &&
    //   this.$refs.videoSelf.srcObject.getTracks()
    // ) {
    //   for (const t of this.$refs.videoSelf.srcObject.getTracks()) {
    //     t.enabled = false;
    //     t.stop();
    //   }
    // }
    // this.$refs.videoSelf.srcObject = null;
    // this.$refs.videoMain.srcObject = null;
    // this.$refs.videoOtherArea.innerHTML = "";
  },
  destroyed() {
    // waitの取得が非同期でロングポーリングになる場合に止めれないため、次を実行させないようにする
    this.isSoraWaitPolling = false;
  },
  methods: {
    async polling() {
      if (this.soraData && this.soraData.sora && this.soraData.sora.login) {
        let res = await ServerAccess.getSoraWait(this.soraData);
        // console.log("wait return");
        // console.log(res);

        let isNext = false;
        switch (res.type) {
          case "update":
            isNext = true;
            this.videoSettingUpdateTrigger++;
            break;
          case "noupdate":
            isNext = true;
            break;

          case "call":
            isNext = true;
            this.callRoomId = res.data.contents;
            break;

          case "logout":
          case "unknown":
            // ログアウトまたはネットワークエラーの場合、
            // トップ画面に遷移する
            this.$router.go({"path": "/", force: true});
            break;

          default:
            // this.actionError();
            break;
        }

        // ログインし直し時にポーリングを停止するため再帰
        if (this.isSoraWaitPolling && isNext) {
          let _this = this;
          setTimeout(function () {
            _this.polling();
          }, 1000);
        }
      }
    },

    async actionCtr(name) {
      switch (name) {
        case "settingwindow":
          this.viewSetting();
          break;
        case "capture":
          this.pushSoraRequestImage();
          break;
        case "mute":
          //
          this.isSelfMute = !this.isSelfMute;
          for (const t of this.$refs.videoSelf.srcObject.getAudioTracks()) {
            t.enabled = !this.isSelfMute;
          }
          break;
        case "videoonoff":
          this.isSelfViewVideo = !this.isSelfViewVideo;
          for (const t of this.$refs.videoSelf.srcObject.getVideoTracks()) {
            t.enabled = this.isSelfViewVideo;
          }
          break;
        case "othervideo":
          this.isOtherVideoView = !this.isOtherVideoView;
          this.$refs.otherAreaDom.style.display = this.isOtherVideoView
            ? "block"
            : "none";

          break;
        case "exit":
          if (this.currentPublisher) {
            try {
              if (this.currentPublisher._ws) {
                this.currentPublisher._ws.send(
                  JSON.stringify({ type: "disconnect" })
                );
              }
              await this.currentPublisher.disconnect();
            } catch (e) {
              console.log(e);
            }
          }
          if (
            this.$refs.videoSelf &&
            this.$refs.videoSelf.srcObject &&
            this.$refs.videoSelf.srcObject.getTracks()
          ) {
            for (const t of this.$refs.videoSelf.srcObject.getTracks()) {
              t.stop();
            }
          }
          this.$refs.videoSelf.srcObject = null;
          this.$refs.videoMain.srcObject = null;
          this.$refs.videoOtherArea.innerHTML = "";
          this.selectRoomId = null;
          this.callRoomId = null;
          this.isSelfViewVideo = true;
          this.isSelfMute = false;
          this.isOtherVideoView = true;
          this.$refs.otherAreaDom.style.display = "block";
          this.viewSetting();

          break;
      }
    },
    async sendFile(file) {
      this.isSendFile = true;
      try {
        let url = await ServerAccess.sendFileToCms(
          file,
          this.soraData.setting.filelinkaccesscode,
          this.soraData.setting.filelinkclientid
        );
        if (!url) throw { message: "file send error" };

        setTimeout(() => {
          this.isSendFile = false;
          console.log("send");
        }, 2000);

        let body = await ServerAccess.setSoraPushChannel(
          this.soraData.sora.sora_api_ssl_uri,
          {
            channel_id: this.selectRoomId,
            data: {
              senderId: this.soraData.sora.user_id,
              senderClientId: this.currentPublisher.clientId,
              senderStreamId: this.currentPublisher.clientId,
              message: JSON.stringify({
                version: 1,
                type: "gyroeye.cmsfile",
                url: url,
              }),
            },
          }
        );
        if (!body || !body.data || body.data.type != "push") {
          throw { message: "push send error" };
        }
      } catch (e) {
        console.log(e);
        alert("送信に失敗しました。再度お試しください。");
      }
      // this.isSendFile = false;
    },
    actionDrawUpdate(d) {
      // console.log("BASE UPDATE");
      // console.log(d);
      this.pushSoraRequestLine(d, false);
    },
    actionDrawFix(d) {
      // console.log("BASE Fix");
      // console.log(d);
      this.drawSoraImageBase64 = null;
      this.pushSoraRequestLine(d, true);
      this.drawSoraImageBaseClientId = null;
    },
    setVideoSetting(d) {
      if (d.media) {
        // videoの選択肢を保存
        let update = this.videoSettingData == null;
        if (!update) {
          for (let key in this.videoSettingData) {
            if (this.videoSettingData[key] != d.media[key]) {
              update = true;
            }
          }
        }

        // ビデオの設定が変わっていたら
        if (update) {
          this.videoSettingData = d.media;
          if (this.currentPublisher) {
            UserMedia.startGetusermedia({
              setting: d.media,
              publisher: this.currentPublisher,
              targetDom: this.$refs.videoSelf,
              // returnFunc: this.eventStartVideoData
            });
          }
        }
      }

      if (d.room && this.selectRoomId == null) {
        this.selectRoomId = d.room.id;
        this.selectCodec = d.media.codec;

        // ビデオの開始

        let r = UserMedia.startVideo({
          soraData: this.soraData,
          soraCodec: this.selectCodec,
          roomData: d.room,
          videoOtherAreaDom: this.$refs.videoOtherArea,
          videoSelfDom: this.$refs.videoSelf,
          videoMainDom: this.$refs.videoMain,
          publisher: this.currentPublisher,
          setting: this.videoSettingData,
          onclick: (targetDom) => {
            // ビデオの切替
            this.$refs.videoMain.srcObject = targetDom.srcObject;
            this.$refs.videoMain.play();

            // 選ばれたものを非表示
            let otherVideos = document.querySelectorAll([
              "video[data-othervideo='1']",
            ]);
            otherVideos.forEach(function (videoItem) {
              if (videoItem.id == targetDom.id) {
                videoItem.style.display = "none";
              } else {
                videoItem.style.display = "inline";
              }
            });
            this.$refs.videoMain.dataset.videoid = targetDom.id;
          },
          onpush: async (event) => {
            console.log(event);
            if (
              event &&
              event.data &&
              event.data.message &&
              event.type == "push"
            ) {
              let d = event.data.message;
              if (typeof d == "string") {
                d = JSON.parse(d);
              }

              switch (d.type) {
                // 書き込み開始
                case "instruction.start":
                  // 画像のリクエストをしていたら終了
                  if (this.isRequestImage) return;
                  // 画像を作成して送信
                  this.pushSoraReturnImage(d, event.data.senderClientId);
                  break;
                // 画像送信
                case "instruction.image":
                  // 画像のリクエストをしていなかったら破棄
                  if (!this.isRequestImage) return;
                  // 描画してる最中なら破棄
                  if (this.drawSoraImageBase64 != null) return;

                  if (this.requestImageId == d.id) {
                    clearTimeout(this.requestImageTimer);
                    this.isRequestImage = false;
                    // 画像を解析して表示
                    let mime = "image/png";
                    if (
                      d.imageFormat.toLowerCase() == "jpg" ||
                      d.imageFormat.toLowerCase() == "jpeg"
                    ) {
                      mime = "image/jpeg";
                    }
                    this.drawSoraImageBaseClientId = event.data.senderClientId;
                    // 下位互換
                    if (this.drawSoraImageBaseClientId == null) {
                      this.drawSoraImageBaseClientId =
                        event.data.senderStreamId;
                    }

                    this.drawSoraImageBase64 =
                      "data:" + mime + ";base64," + d.image;
                  }
                  break;
                // 書き込みデータ送信
                case "instruction.contents":
                case "instruction.finish":
                  break;
                case "gyroeye.cmsfile":
                  if (event.data.senderId != this.soraData.sora.user_id) {
                    // console.warn(
                    //   "ファイル受信は現在ブラウザでは対応していません。"
                    // );
                    // 現段階ではTOKENでCROSS設定されていないので、ブラウザで取得できない

                    // if (
                    //   window.confirm("ファイルを受信しました。開きますか？")
                    // ) {
                    try {
                      let message = JSON.parse(event.data.message);
                      // fileAccessToken
                      let d = await ServerAccess.getFileUrlFronCms(
                        message.url,
                        this.soraData.setting.filelinkaccesscode,
                        this.soraData.setting.filelinkclientid
                      );
                      console.log(d);
                      if (!d.url) throw { message: "fileurl get error" };

                      this.$refs.receiveFileLink.href = d.url;
                      this.fileAccessToken = d.authToken;
                    } catch (e) {
                      console.log(e);
                    }
                    // }
                  }
                  break;
              }
            }
          },
        });

        this.currentPublisher = r.publisher;
      }
      // ウィンドウの非表示
      this.isViewVideoSetting = false;
    },

    viewSetting() {
      // 設定画面の表示
      this.isViewVideoSetting = !this.isViewVideoSetting;
    },
    actionError() {
      alert("エラーが発生しました。もう一度ログインしなおしてください。");
      this.$router.push({
        name: "login",
      });
    },

    // 線の送信
    async pushSoraRequestLine(d, isFix) {
      // console.log("線の送信");

      if (!this.selectRoomId) {
        alert("ROOMが選択されていません");
        return;
      }
      if (!this.currentPublisher) {
        alert("WebRTCに接続していません");
        return;
      }

      if (!this.drawSoraImageBaseClientId) {
        alert(
          "描画情報の送信先が正しく設定されていません。再度行ってください。"
        );
        this.drawSoraImageBase64 = null;
        this.drawSoraImageBaseClientId = null;
        return;
      }

      let body;
      const sendPushMessage = {
        channel_id: this.selectRoomId,
        data: {
          senderId: this.soraData.sora.user_id,
          senderClientId: this.currentPublisher.clientId,
          senderStreamId: this.currentPublisher.clientId,
          message: JSON.stringify({
            version: 1,
            type: isFix ? "instruction.finish" : "instruction.contents",
            id: this.requestImageId,
            line: d,
          }),
        },
      };

      sendPushMessage.client_id = this.drawSoraImageBaseClientId;
      body = await ServerAccess.setSoraPushClient(
        this.soraData.sora.sora_api_ssl_uri,
        sendPushMessage
      );

      if (!body || !body.data || body.data.type != "push") {
        console.log("no send line");
      }
    },

    // 画像の送信
    async pushSoraRequestImage() {
      console.log("画像リクエスト");

      if (!this.selectRoomId) {
        alert("ROOMが選択されていません");
        return;
      }
      if (!this.currentPublisher) {
        alert("WebRTCに接続していません");
        return;
      }

      if (
        !this.$refs.videoMain ||
        !this.$refs.videoMain.srcObject ||
        !this.$refs.videoMain.srcObject.id
      ) {
        alert("メインが選ばれていません。");
        return;
      }

      this.isRequestImage = true;
      this.requestImageId = "pic" + Math.floor(Math.random() * 100);
      this.requestImageTimer = setTimeout(() => {
        alert(
          "取得できませんでした。時間をおいて再度実行してください。[timeout]"
        );
        this.isRequestImage = false;
        this.requestImageId = null;
      }, 15000);

      let body = await ServerAccess.setSoraPushConnection(
        this.soraData.sora.sora_api_ssl_uri,
        {
          channel_id: this.selectRoomId,
          connection_id: this.$refs.videoMain.srcObject.id,
          data: {
            senderId: this.soraData.sora.user_id,
            senderClientId: this.currentPublisher.clientId,
            senderStreamId: this.currentPublisher.clientId,
            message: JSON.stringify({
              version: 1,
              type: "instruction.start",
              id: this.requestImageId,
            }),
          },
        }
      );
      if (!body || !body.data || body.data.type != "push") {
        alert(
          "取得できませんでした。時間をおいて再度実行してください。[servererror]"
        );
        this.isRequestImage = false;
        this.requestImageId = null;
        clearTimeout(this.requestImageTimer);
      }
    },
    async pushSoraReturnImage(data, clientId) {
      console.log("画像を作成して返信");
      console.log(clientId);

      if (!this.selectRoomId) {
        alert("ROOMが選択されていません");
        return;
      }
      if (!this.currentPublisher) {
        alert("WebRTCに接続していmせん");
        return;
      }

      let video = this.$refs.videoSelf;

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      var type = "image/jpeg";
      let base64img = canvas.toDataURL(type);
      base64img = base64img.substr(base64img.indexOf(",") + 1);

      let body = await ServerAccess.setSoraPushClient(
        this.soraData.sora.sora_api_ssl_uri,
        {
          channel_id: this.selectRoomId,
          client_id: clientId,
          data: {
            senderId: this.soraData.sora.user_id,
            senderClientId: this.currentPublisher.clientId,
            senderStreamId: this.currentPublisher.clientId,
            message: JSON.stringify({
              type: "instruction.image",
              id: data.id,
              image: base64img,
              imageFormat: "jpg",
            }),
          },
        }
      );
      if (!body || !body.data || body.data.type != "push") {
        console.log(body);
        alert("画像が送信できませんでした");
      }
    },
    async receiveFileClose() {
      try {
        await ServerAccess.getCmsLogout(this.fileAccessToken);
      } catch (e) {
        console.log(e);
      }
      this.fileAccessToken = null;
    },
  },
  watch: {
    soraData: function (val) {
      console.log("----watch video soraData-------");
      console.log(val);
    },
  },
  components: {
    VideoSetting,
    VideoDraw,
    VideoCtr,
  },
};
</script>

<style scoped>
.leftWindow {
  position: fixed;
  top: 50px;
  left: 0px;
  width: 400px;
  border-radius: 0 5px 5px 0;
  border: 2px solid white;
  border-left: none;
}
.ctrWindow {
  position: fixed;
  width: 100%;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
}
.videoSelfWindow {
  position: fixed;
  width: 240px;
  bottom: 80px;
  right: 10px;
}
.mainVideoWindow {
  position: fixed;
  width: 100%;
  top: 50px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mainVideo {
  width: 100%;
}

@media (min-aspect-ratio: 4/3) {
  .mainVideo {
    height: 100%;
  }

  .mainVideoWindow {
    height: 90%;
  }
}

.mainVideoWidthHalf {
  width: 50%;
  margin: 0 auto;
  display: block;
}

.window {
  padding: 10px;
  background-color: rgba(128, 128, 128, 0.9);
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue